/* SDC cart guard: keeps booked installs intact in the cart.
 * Booking lines carry _booking_id (shared by every line of one booking) and _booking_lines
 * (how many lines the booking was added with). On load this script:
 *   1. snaps any booking line with quantity > 1 back to 1
 *   2. removes the rest of a booking that has lost one of its lines
 *   3. removes the deposit plan when nothing in the cart is booked any more and no line
 *      carries properties (the "orphaned deposit": shipped-only items checking out at 10% down)
 * and makes the remove button on a booking line remove the whole booking. If the cart still holds
 * two or more appointments (one order can only hold one), it shows a notice on the cart page.
 * One fix per pass (Shopify's change.js works by line number, which shifts after each change),
 * then the page reloads so the cart totals are fresh. If anything fails, it does nothing.
 */
(function () {
  if (window.__sdcCartGuard) return;
  window.__sdcCartGuard = true;

  var MAX_PASSES = 20;
  var props = function (it) { return it.properties || {}; };
  var bookingId = function (it) { return props(it)._booking_id || ''; };
  // A booked line counts only with both a date and a start time (a booking can't go through without one)
  var hasAppointment = function (it) {
    var p = props(it);
    return !!((p['Appointment Date'] || p._appointment_date) && (p['Appointment Time'] || p._appointment_time || p._slot_id));
  };

  function post(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { if (!r.ok) throw new Error(url + ' ' + r.status); return r.json(); });
  }
  function getCart() {
    return fetch('/cart.js', { cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); });
  }
  function removeKeys(keys) {
    var updates = {};
    keys.forEach(function (k) { updates[k] = 0; });
    return post('/cart/update.js', { updates: updates });
  }

  // Returns a promise of true if it changed something, false if the cart is clean.
  function fixOnce(cart) {
    var items = cart.items || [];
    var groups = {};
    items.forEach(function (it) { var id = bookingId(it); if (id) (groups[id] = groups[id] || []).push(it); });

    // 1. booked lines are always quantity 1
    for (var i = 0; i < items.length; i++) {
      if (bookingId(items[i]) && items[i].quantity > 1) {
        return post('/cart/change.js', { line: i + 1, quantity: 1 }).then(function () { return true; });
      }
    }
    // 2. a booking missing any of its lines is removed as a whole
    for (var id in groups) {
      var g = groups[id];
      var expected = parseInt(props(g[0])._booking_lines, 10);
      var broken = (expected && g.length < expected) || !g.some(hasAppointment);
      if (broken) return removeKeys(g.map(function (x) { return x.key; })).then(function () { return true; });
    }
    // 3. deposit plans with nothing booked: plans come off (full price). Only when NO line has
    //    any properties at all, so carts from the older booking pages (which tag lines with
    //    their own properties) are never touched.
    var anyProps = items.some(function (it) { return Object.keys(props(it)).some(function (k) { return props(it)[k] !== '' && props(it)[k] != null; }); });
    if (!anyProps) {
      for (var j = 0; j < items.length; j++) {
        if (items[j].selling_plan_allocation) {
          return post('/cart/change.js', { line: j + 1, quantity: items[j].quantity, selling_plan: null })
            .then(function () { return true; });
        }
      }
    }
    return Promise.resolve(false);
  }

  // Two complete appointments in one cart: say so above the cart (never removes anything itself)
  function noticeMultiple(cart) {
    var ids = {};
    (cart.items || []).forEach(function (it) { if (bookingId(it) && hasAppointment(it)) ids[bookingId(it)] = 1; });
    var n = Object.keys(ids).length;
    var form = document.getElementById('main-cart-items');
    var old = document.getElementById('sdc-multi-appt');
    if (old) old.remove();
    if (n < 2 || !form) return;
    var d = document.createElement('div');
    d.id = 'sdc-multi-appt';
    d.setAttribute('role', 'alert');
    d.style.cssText = 'border:2px solid #b23b1a;background:#fff5f2;color:#1a1a1a;border-radius:8px;padding:12px 14px;margin:0 0 16px;font-size:15px;line-height:1.45';
    d.textContent = 'Your cart has ' + n + ' installation appointments, but one order can hold one appointment. Remove one before checking out, or text or call (206) 552-0856 and we\'ll book both.';
    form.parentNode.insertBefore(d, form);
  }

  function run() {
    var changed = false, passes = 0, lastCart = null;
    function loop() {
      if (passes++ >= MAX_PASSES) return finish();
      return getCart().then(function (cart) { lastCart = cart; return fixOnce(cart); }).then(function (did) {
        if (did) { changed = true; return loop(); }
        return finish();
      });
    }
    function finish() {
      if (!changed) { if (lastCart) noticeMultiple(lastCart); return; }
      // Reload once so totals and line items re-render. Guard against reload loops.
      var key = 'sdcCartGuardReload', last = 0;
      try { last = parseInt(sessionStorage.getItem(key), 10) || 0; } catch (e) {}
      if (Date.now() - last < 10000) return;
      try { sessionStorage.setItem(key, String(Date.now())); } catch (e) {}
      location.reload();
    }
    return loop().catch(function (e) { console.warn('[sdc-cart-guard]', e); });
  }

  // Remove button on a booking line removes every line of that booking.
  document.addEventListener('click', function (ev) {
    var el = ev.target.closest && ev.target.closest('sdc-booking-remove');
    if (!el) return;
    var id = el.getAttribute('data-booking-id');
    if (!id) return;
    ev.preventDefault();
    getCart().then(function (cart) {
      var lines = (cart.items || []).filter(function (it) { return bookingId(it) === id; });
      // An appointment for 2+ vehicles comes out as a whole (the 10% multi-vehicle labor price and
      // the appointment length only fit the full set), so say so before removing it.
      var vehicles = {};
      lines.forEach(function (it) { var v = props(it)._vehicle; if (v) vehicles[v] = 1; });
      var n = Object.keys(vehicles).length;
      var all = n === 2 ? 'both vehicles' : 'all ' + n + ' vehicles';
      if (n > 1 && !window.confirm('This appointment is for ' + n + ' vehicles. Removing this removes the whole appointment for ' + all + ', so the price and appointment time stay right. You can book again in a minute.\n\nRemove the whole appointment?')) return;
      var keys = lines.map(function (it) { return it.key; });
      if (!keys.length) return location.reload();
      return removeKeys(keys).then(function () { location.reload(); });
    }).catch(function () {
      var a = el.querySelector('a[href]');
      if (a) location.href = a.href; // fall back to removing just this line; the guard tidies the rest
    });
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
})();
